import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import { InputCodeEditor } from "../../../common/controls";
import { ShowNumber } from "../../../common/controls";
import { ShowBoolean } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type DashboardWidgetViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  widgetKeyValue?: { displayId: string; id: string } | null;
  widgetKey: string;
  titleValue?: { displayId: string; id: string } | null;
  title: string;
  descriptionValue?: { displayId: string; id: string } | null;
  description: string;
  categoryValue?: { displayId: string; id: string } | null;
  category: string;
  componentValue?: { displayId: string; id: string } | null;
  component: string;
  dataFetcherKeyValue?: { displayId: string; id: string } | null;
  dataFetcherKey: string;
  defaultConfigValue?: { displayId: string; id: string } | null;
  defaultConfig: string;
  iconValue?: { displayId: string; id: string } | null;
  icon: string;
  minWidthValue?: { displayId: string; id: string } | null;
  minWidth: number;
  minHeightValue?: { displayId: string; id: string } | null;
  minHeight: number;
  refreshIntervalValue?: { displayId: string; id: string } | null;
  refreshInterval: number | undefined;
  requiredPermissionsValue?: { displayId: string; id: string } | null;
  requiredPermissions: string;
  enabledValue?: { displayId: string; id: string } | null;
  enabled: boolean;
};

export const DashboardWidgetViewForm: React.FC<DashboardWidgetViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      widgetKey = "",
      title = "",
      description = "",
      category = "",
      component = "",
      dataFetcherKey = "",
      defaultConfig = "{}",
      icon = "",
      minWidth = 0,
      minHeight = 0,
      refreshInterval = 0,
      requiredPermissions = "",
      enabled = false,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupDashboardWidgetLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowMultiLine
                  value={widgetKey}
                  label={langStore.DashboardWidgetWidgetKeyLabel}
                />
                <ShowMultiLine
                  value={title}
                  label={langStore.DashboardWidgetTitleLabel}
                />
                <ShowMultiLine
                  value={description}
                  label={langStore.DashboardWidgetDescriptionLabel}
                />
                <ShowMultiLine
                  value={category}
                  label={langStore.DashboardWidgetCategoryLabel}
                />
                <ShowMultiLine
                  value={component}
                  label={langStore.DashboardWidgetComponentLabel}
                />
                <ShowMultiLine
                  value={dataFetcherKey}
                  label={langStore.DashboardWidgetDataFetcherKeyLabel}
                />
                <InputCodeEditor
                  value={defaultConfig}
                  onChange={() => {}}
                  label={langStore.DashboardWidgetDefaultConfigLabel}
                  language="json"
                  readOnly={true}
                />
                <ShowMultiLine
                  value={icon}
                  label={langStore.DashboardWidgetIconLabel}
                />
                <ShowNumber
                  value={minWidth}
                  label={langStore.DashboardWidgetMinWidthLabel}
                />
                <ShowNumber
                  value={minHeight}
                  label={langStore.DashboardWidgetMinHeightLabel}
                />
                <ShowNumber
                  value={refreshInterval}
                  label={langStore.DashboardWidgetRefreshIntervalLabel}
                />
                <ShowMultiLine
                  value={requiredPermissions}
                  label={langStore.DashboardWidgetRequiredPermissionsLabel}
                />
                <ShowBoolean
                  value={enabled}
                  label={langStore.DashboardWidgetEnabledLabel}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
